import _tmpl from "./lightningElementSLDS.html";
import { registerComponent as _registerComponent, LightningElement } from "lwc";
class LightningElementSLDS extends LightningElement {
  constructor() {
    super();

    // // Add SLDS CSS
    //let _sldsPath = '../SLDS/styles';
    let _sldsPath = './resources/SLDS/styles';
    _sldsPath += '/salesforce-lightning-design-system.css';
    const styles = document.createElement('link');
    styles.href = _sldsPath;
    styles.rel = 'stylesheet';
    this.template.appendChild(styles);
  }
}
export default _registerComponent(LightningElementSLDS, {
  tmpl: _tmpl
});